import styled from '@emotion/styled'

export const StatusTag = styled.div(
  ({ enabled }: { enabled: boolean }) => `
  color: ${enabled ? '#4EB21C' : '#E2232D'};
  font-size: 12px;
  font-weight: 500;

  display: flex;
  align-items: center;
  gap: 8px;
`
)

export const StatusIcon = styled.div(
  ({ enabled }: { enabled: boolean }) => `
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${enabled ? '#4EB21C' : '#E2232D'};
`
)
